import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { CTConfigurationModel } from '../../../_core/classes/ct-configuration-model';
import { CtManagerService } from '../../../_core/lib/ct-manager.service';
import { CTExpansionPanelConfiguration, CTSingleComponentConfiguration, CTTabConfiguration } from '@ctsolution/ct-framework';

@Component({
  selector: 'app-scheduler-legend',
  templateUrl: './scheduler-legend.component.html',
  styleUrls: ['./scheduler-legend.component.scss']
})
export class SchedulerLegendComponent implements OnInit {

  legendItemsConfiguration: CTConfigurationModel = CTConfigurationModel.create().setVisible(false);
  panelConfiguration: CTTabConfiguration | null = null;
  @ViewChild('legendTemplate') legendTemplate!: TemplateRef<any>;


  constructor(private managerService: CtManagerService) { }


  async ngOnInit(): Promise<void> {

    await this.managerService.getComponentOverride("scheduler", "legendItemsConfiguration", this.legendItemsConfiguration).then((component) => {
      return;
    })

    this.panelConfiguration = CTExpansionPanelConfiguration
      .create([
        CTSingleComponentConfiguration.create(this.legendTemplate).setLabel("Legenda").setExpanded(true)])
      .setButtonsVisible(false);

  }


  getRgbaBackground(hex: string, opacity = 0.15): string {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  }


}